import { render, staticRenderFns } from "./ProjectSummaryBarChart.vue?vue&type=template&id=2fe8669a"
import script from "./ProjectSummaryBarChart.vue?vue&type=script&lang=ts"
export * from "./ProjectSummaryBarChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports